import { useSelector } from "../../hooks";
import { Loader } from "../../components/Loader/Loader";
import { ErrorSnackbar } from "../../components/ErrorSnackbar/ErrorSnackbar";
import { WorkRoutes } from "./WorkRoutes";

export enum WorkContext {
    Button = 'button',
    Upgrade = 'upgrade',
}

export const WorkPage = () => {
    const { loading, error } = useSelector(store => store.work);

    return (
        <>
            <WorkRoutes />

            { loading && <Loader /> }
            { error.length > 0 && <ErrorSnackbar errorMessage={ error } /> }
        </>
    );
}